import {useEffect, useState} from "react";
import useToken from "./useToken";
import {BmeShop} from "./BmeShop";

export default function useUser() {
    const [token] = useToken();
    const [user, setUser] = useState(null);

    const refreshUser = () => {
        if (token) {
            BmeShop.user.self(token)
                .then(setUser)
                .catch(console.log);
        } else {
            setUser({});
        }
    }

    useEffect(refreshUser, [token]);

    return [user, refreshUser];
}